/** One discipline's level, for a sport assessed per discipline (ski). */
export interface UserSportDisciplineLevel {
  disciplineId: string;
  level: number;
  percent: number;
  date: string;
  answerSentence: string | { en?: string; fr?: string };
}

export class UserSportLevel {
  id: string;
  icon: string;
  level: number;
  percent: number;
  label: string;
  date: string;
  answerSentence: string | { en?: string; fr?: string };
  /**
   * Present only on a sport assessed per discipline (ski): one entry per
   * discipline the member has rated. The flat `level`/`percent` above then hold
   * the sport's overall figure (its strongest discipline), for the one-row
   * summary in lists; the breakdown here drives the sport's own page.
   */
  disciplines?: UserSportDisciplineLevel[];

  constructor(
    id: string,
    icon: string,
    level: number,
    percent: number,
    label: string,
    date: string,
    answerSentence: string | { en?: string; fr?: string },
    disciplines?: UserSportDisciplineLevel[],
  ) {
    this.id = id;
    this.icon = icon;
    this.level = level;
    this.percent = percent;
    this.label = label;
    this.date = date;
    this.answerSentence = answerSentence;
    this.disciplines = disciplines;
  }
}
